import { useStateContext } from "context/StateContext"
import { Helmet } from "react-helmet-async"

export default function Skills() {
    const { darkMode } = useStateContext()
    let accordionData = [
        {
            id: "html5",
            skill: "HTML 5",
            skillDetail: "العميل نفسه، سيكون العميل قادرا على متابعة للشركة. الحياة، هو! فماذا سينتقد الفاسد ممارسة هذه إلا آلام الملذات!",
            skillPercentage: "95%"
        },
        {
            id: "css3",
            skill: "CSS 3",
            skillDetail: "العميل نفسه، سيكون العميل قادرا على متابعة للشركة. الحياة، هو! فماذا سينتقد الفاسد ممارسة هذه إلا آلام الملذات!",
            skillPercentage: "93%"
        },
        {
            id: "bootstrap",
            skill: "Bootstrap",
            skillDetail: "العميل نفسه، سيكون العميل قادرا على متابعة للشركة. الحياة، هو! فماذا سينتقد الفاسد ممارسة هذه إلا آلام الملذات!",
            skillPercentage: "95%"
        },
        {
            id: "javaScript",
            skill: "JavaScript",
            skillDetail: "العميل نفسه، سيكون العميل قادرا على متابعة للشركة. الحياة، هو! فماذا سينتقد الفاسد ممارسة هذه إلا آلام الملذات!",
            skillPercentage: "80%"
        },
        {
            id: "reactjS",
            skill: "React JS",
            skillDetail: "العميل نفسه، سيكون العميل قادرا على متابعة للشركة. الحياة، هو! فماذا سينتقد الفاسد ممارسة هذه إلا آلام الملذات!",
            skillPercentage: "80%"
        },
        {
            id: "firebase",
            skill: "Firebase",
            skillDetail: "العميل نفسه، سيكون العميل قادرا على متابعة للشركة. الحياة، هو! فماذا سينتقد الفاسد ممارسة هذه إلا آلام الملذات!",
            skillPercentage: "90%"
        },
        {
            id: "mongodb",
            skill: "Mongo DB",
            skillDetail: "العميل نفسه، سيكون العميل قادرا على متابعة للشركة. الحياة، هو! فماذا سينتقد الفاسد ممارسة هذه إلا آلام الملذات!",
            skillPercentage: "75%"
        },
        {
            id: "expressjs",
            skill: "Express JS",
            skillDetail: "العميل نفسه، سيكون العميل قادرا على متابعة للشركة. الحياة، هو! فماذا سينتقد الفاسد ممارسة هذه إلا آلام الملذات!",
            skillPercentage: "60%"
        },
    ]

    return (
        <>
            <Helmet>
                {/* <Helmet/> component is used to change title, description and tags for each pages. Normally ReactJS use just one "html" file so we can't change title 
        for each page. Helmet is an external library used to add this feature */}
                <meta charSet="utf-8" />
                <title> ستيفن اريك | مهارات</title>
            </Helmet>
            <div className="container" id="skills-section-right-to-left" data-aos="fade-left">
                <div className="row py-4 first">
                    <div className="col text-style position-relative d-flex justify-content-center">
                        <h1 className={`${darkMode ? "text-body" : "text-body-tertiary"} fw-bold `}>مهارات</h1>
                        <h4 className='position-absolute align-self-center '>خبرة</h4>
                    </div>
                </div>

                {/* skills */}
                <div className="my-skills py-5">
                    <div className="accordion accordion-flush" id="accordionFlushExample">
                        <div className="row g-4 g-sm-3 g-xl-4 px-0 px-md-3 px-lg-5 row-cols-1 row-cols-sm-2 ">
                            {accordionData.map((item, i) => {
                                return <div className="col" key={i}>
                                    <div className="card border-info shadow overflow-hidden">
                                        <div className="accordion-item border-0">
                                            <h2 className="accordion-header">
                                                <button className="accordion-button collapsed bg-transparent text-body" type="button" data-bs-toggle="collapse" data-bs-target={`#${item.id}`} aria-expanded="false" aria-controls="flush-collapseOne">
                                                    <h6>{item.skill}</h6>
                                                </button>
                                            </h2>
                                            <div id={item.id} className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                                <p className="accordion-body">{item.skillDetail}</p>
                                            </div>
                                        </div>
                                        <div className="progress bg-transparent rounded-0" role="progressbar" aria-label="Info example"
                                            aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                                            <div className="progress-bar bg-info"
                                                style={{ width: item.skillPercentage }}>{item.skillPercentage}</div>
                                        </div>
                                    </div>
                                </div>
                            })}

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
